import { Tooltip } from 'ui-toolkit/components/Tooltip/Tooltip';
import { ILineItem } from '../ILineItem';
import React from 'react';
import { BodyText } from 'ui-toolkit/components/Typography/basicTypography';
import { BadgeTW } from '../../../../tailwindComponents/badgeTW/BadgeTW';

export interface IPayeeColumnProps {
  columnValue: any;
  fee?: ILineItem;
}

export const PayeeColumn: React.FC<IPayeeColumnProps> = ({ columnValue, fee }) => {
  const iconNumber = fee?.feePayees && fee?.feePayees?.length - 1;
  return (
    <div>
      {columnValue || '--'}
      {fee?.feePayees && fee?.feePayees.length > 1 && (
        <div className={'inline align-baseline'}>
          <Tooltip
            placement={'bottom'}
            trigger={'hover'}
            tooltipContent={<BodyText>{fee.feePayees.slice(1).join(', ')}</BodyText>}
          >
            <BadgeTW className={'bg-blue-100 text-blue-800'}>+{iconNumber}</BadgeTW>
          </Tooltip>
        </div>
      )}
    </div>
  );
};
